import { render, staticRenderFns } from "./hotel-info.vue?vue&type=template&id=54b1df72"
import script from "./hotel-info.vue?vue&type=script&lang=js"
export * from "./hotel-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports